<template>
  <div class="ed-switch">
    <button class="ed-switch__part ed-btn-squared" :class="{ 'ed-u-color-primary': thisList, 'ed-switch--disabled': thisList }" @click="changeViewList"><slot name="view1"></slot></button>
    <button class="ed-switch__part ed-btn-squared" :class="{ 'ed-u-color-primary': !thisList, 'ed-switch--disabled': !thisList }" @click="changeViewNotList"><slot name="view2"></slot></button>
  </div>
</template>

<script>
  export default {
    name: 'SwitchView',
    props: {
      data: Boolean,
    },
    data() {
      return {
        thisList: this.data,
      };
    },
    methods: {
      changeViewList($event) {
        if (!this.thisList) {
          this.thisList = true;
          this.$emit('click', this.thisList, $event);
        }
      },
      changeViewNotList($event) {
        if (this.thisList) {
          this.thisList = false;
          this.$emit('click', this.thisList, $event);
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// switchView.vue?0bbbbe1c